import React from "react";

type Props = {
  width: number;
  height: number;
};

export const IconTeamOwnerSVG: React.FC<Props> = (props) => {
  const { width, height } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 34 34`}
    >
      <g transform="translate(5.687 4.499)">
        <rect
          width="34"
          height="34"
          transform="translate(-5.687 -4.499)"
          fill="rgba(0,0,0,0)"
          opacity="0"
        />
        <g transform="translate(0.313 -0.303)" clipPath="url(#clip-path)">
          <path
            d="M20.945,5.234C17.062,4.733,13.323,1.71,11.763.3a1.13,1.13,0,0,0-1.527,0c-1.56,1.412-5.3,4.435-9.182,4.936A1.22,1.22,0,0,0,0,6.5c.478,12.281,8.241,17.67,10.429,18.95a1.117,1.117,0,0,0,1.141,0C13.758,24.173,21.52,18.785,22,6.5a1.22,1.22,0,0,0-1.054-1.269M11,18.9a5.977,5.977,0,0,1-5.856-6.091A5.977,5.977,0,0,1,11,6.714a5.977,5.977,0,0,1,5.856,6.091A5.977,5.977,0,0,1,11,18.9"
            transform="translate(0 0)"
          />
          <path
            d="M18.923,16.854l-1.852-.28-.828-1.746c-.286-.6-.75-.6-1.036,0l-.828,1.746-1.852.28c-.64.1-.784.556-.32,1.026l1.34,1.358-.316,1.919c-.109.663.266.947.839.633l1.656-.906,1.656.906c.572.314.947.03.839-.633L17.9,19.238l1.339-1.358c.463-.469.32-.929-.32-1.026"
            transform="translate(-4.725 -5.342)"
          />
        </g>
      </g>
    </svg>
  );
};
